export default "__VITE_ASSET__482e8f52__"